(function () {
    'use strict';

    angular.module('app').controller('CreateMarginModalController', CreateMarginModalController);
    CreateMarginModalController.$inject = [
        'ClientService',
        'toastr',
        '$uibModalInstance',
        'ServicesService',
        'serviceProfileIds'
    ];

    function CreateMarginModalController(
        ClientService,
        toastr,
        $uibModalInstance,
        ServicesService,
        serviceProfileIds
    ) {
        const vm = this;
        vm.isLoading = false;

        vm.onSubmit = onSubmit;
        vm.closeModal = closeModal;
        vm.getClientCompany = getClientCompany;

        init();

        function init() {
            setDefaultCloneMarginName();
        }

        function setDefaultCloneMarginName() {

            vm.plan = [{
                id: 1,
                name: 'PLAN LITE'
            }, {
                id: 2,
                name: 'PLAN ENTERPRISE '
            }, {
                id: 3,
                name: 'PLAN PLATINUM'
            }, {
                id: 4,
                name: 'PLAN PLATINUM PLUS'
            }, {
                id: 5,
                name: 'PLAN PLATINUM GALAXY'
            }, {
                id: 6,
                name: 'PLAN HOUSE ACCOUNT'
            }]

            getClientCompany();
        }

        function getClientCompany(data) {

            ClientService.Company.getAll(
                res => {
                    vm.companies = res.content
                },
                err => {
                    toastr.error(err.message);
                },
                {
                    name: data,
                    size: 10
                }
            )
        }

        function onSubmit(form) {
            if (form.$invalid) {
                form.$setSubmitted();
                return;
            }

            createMargin();
        }

        function cleanPayload() {
            const offices = [];
            const serviceProfileId = [];
            vm.createMargin.companyOffices.forEach(office => {
                offices.push({ id: office.id, offices: [] })
            });
            serviceProfileIds.forEach(serviceProfile => {
                serviceProfileId.push(serviceProfile.id)
            });


            const payload = {
                serviceProfileIds: serviceProfileId,
                planId: vm.createMargin.plan.id,
                marginValue: vm.createMargin.marginValue,
                marginPercent: vm.createMargin.marginPercent,
                companyOffices: offices
            }

            return payload;
        }

        function createMargin() {
            vm.isLoading = true;
            const payload = cleanPayload();
            ServicesService.autoCrateMargin(payload, success => {
                toastr.success('Successfully created', 'Success!');
                vm.isLoading = false;
                $uibModalInstance.close();
            }, error => {
                vm.isLoading = false;
                toastr.error(error.message, 'Error!');
            }, { name: vm.name })
        }

        function closeModal() {
            $uibModalInstance.close();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/services/modals/CreateMarginModalController.js